import { CollectionChildNodeType } from '../../../../io/models/collection-child-node-type'
import { CollectionEntityType } from '../../../../io/models/collection'
import { buildContentTagString, CoreAPITag } from '../../../shared/analytics/services/segment.utility'

/**
 * For Segment Page Calls
 * @param parentType, type of the parent collection, 'person', 'team', 'supporter'
 * @param tabType, type of the tabbed content, ex: 'event', 'article'
 * @param capitalizeTabType, same as tabType, but capitalized, ex: Event, Article
 * @param capitalizeView, 'Completed' | 'Live-and-upcoming'
 *
 * ex: name: Collection - Live-and-upcoming Event
 */
export const buildCollectionTabPageName = (
  parentType: CollectionEntityType | undefined,
  tabType: CollectionChildNodeType,
  capitalizeTabType: string,
  capitalizeView: string | undefined
): string => {
  const pageCat = parentType === 'person' ? 'People' : parentType === 'team' ? 'Teams' : 'Collection'
  return `${pageCat} - ${tabType === 'event' ? capitalizeView + ' ' + capitalizeTabType : capitalizeTabType}`
}

/**
 * For Segment Page Calls
 * @param videoSelected, ex: user has selected a video on the collection page
 * @param type, ex: type of the original entity in the collection
 */
export const buildCollectionTabPageCategory = (videoSelected: boolean, type?: CollectionEntityType | null): string => {
  // If Person or Team, page category will be People or Team, else Collection
  const personOrTeam = type === 'person' ? 'People' : type === 'team' ? 'Teams' : undefined
  return videoSelected ? 'Video' : !!personOrTeam ? personOrTeam : 'Collection'
}

/**
 * For Segment Page Calls
 * @param videoSelected, ex: user has selected a video to play
 * @param tags, ex: the category tags below the playing video
 */
export const buildCollectionTabPageContentTags = (
  videoSelected: boolean,
  tags: ReadonlyArray<CoreAPITag> | undefined
): string | undefined => {
  return videoSelected && !!tags ? buildContentTagString(tags) : undefined
}
